import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { withTheme, Dialog, Grid } from '@material-ui/core';
import { compose } from "recompose";

const styles = theme => ({
    dialog: { padding: '20px', width: '400px', backgroundColor: theme.ModalBGColor },
    eventName: { fontWeight: 'bold',  color: theme.TextColor, alignSelf: 'center' },
    textColumn : { display : "flex" }
})

function LoaderDialog(props) {
    const { classes, eventName, ...otherProps} = props;
    return (
        <Dialog onClose={props.onCancel} classes={{ paper: classes.dialog }} open={true} {...(otherProps || {})}>
            <Grid container>
                <Grid item xs={3}><CircularProgress /></Grid>
                <Grid item xs={7} className={classes.textColumn}><span className={classes.eventName}>{eventName} is in progress</span></Grid>
            </Grid >
        </Dialog>
    )
}
export default compose(
    withTheme(),
    withStyles(styles)
)(LoaderDialog);
